import { PlusOutlined, EditTwoTone, EyeFilled, LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Spin, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { CarAllowanceOptionList, FuelType, FuelTypesOptionList, ICarCo2Emmission, ICarEleRanage, ICarEngineSize } from "../../Services/PayrollYearlySettingsService";
import Link from "antd/es/typography/Link";
import { ListParams } from "./PayrollYearlySettingsDetails";

export type ICarAllowancesTypeList =
  | ICarCo2Emmission
  | ICarEngineSize
  | ICarEleRanage;
interface iTaxDataProps {
  isViewOnly: boolean;
  OnCancelClick: () => void;
  setDialog: React.Dispatch<
    React.SetStateAction<{
      type: string;
      params: any;
    }>
  >;
  listParams: ListParams;
  setListParams: React.Dispatch<React.SetStateAction<ListParams>>;
  carAllowancesTypeList: ICarAllowancesTypeList[]
}

const CarAllowances = ({
  isViewOnly = false,
  OnCancelClick,
  setDialog,
  listParams,
  setListParams,
  carAllowancesTypeList,
}: iTaxDataProps) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [payFrequencyFilter, setPayFrequencyFilter] = React.useState<FuelType[]>([]);
  const [carAllowancesTypeListData, setCarAllowancesTypeListData] = React.useState<ICarAllowancesTypeList[]>(
    carAllowancesTypeList
  );
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 15,
  });
  const [isOld, setIsOld] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    if (carAllowancesTypeList?.length > 0) {
      // setLoading(true)
      let lst = carAllowancesTypeList;

      const hasPayFreq =
        Array.isArray(payFrequencyFilter) &&
        payFrequencyFilter.length > 0;

      const hasIsOld = isOld !== null;

      lst = lst.filter((item: ICarAllowancesTypeList) => {

        /* ---- Fuel Type Filter ---- */
        const fuelMatch = hasPayFreq
          ? payFrequencyFilter.includes(item.fuelType)
          : true;

        /* ---- isOld Filter ---- */
        const isOldMatch = hasIsOld
          ? item.isOld === isOld
          : true;

        return fuelMatch && isOldMatch;
      });

      setCarAllowancesTypeListData(lst);
      // setLoading(false)
    } else {
      setCarAllowancesTypeListData([]);
      // setLoading(false)
    }
  }, [carAllowancesTypeList, payFrequencyFilter, isOld]);

  type ColumnConfig = {
    title: string;
    key: string;
  };

  const columnMap: Record<number, ColumnConfig> = {
    1: {
      title: "Co2 Emmision",
      key: "co2Emmision",
    },
    2: {
      title: "Engine Size",
      key: "engineSize",
    },
    3: {
      title: "Electric Range",
      key: "eleRange",
    },
  };

  const type = listParams?.carAllowancesListType ?? 1;
  const config = columnMap[type];

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "4%",
      render: (_: any, record: any, index: any) => <p>{(pagination.current - 1) * pagination.pageSize + index + 1}</p>,
    },
    {
      title: "Old ",
      dataIndex: "isOld",
      key: "IsOld",
      width: "16%",
      render: (_: any, record: any, index: any) => <>{record?.isOld ? "Yes" : "No"}</>
    },
    {
      title: "Fuel Type",
      dataIndex: "fuelType",
      key: "FuelType",
      width: "20%",
      render: (_: any, record: any, index: any) => <>{FuelType[record?.fuelType]}</>
    },   
    {
      title: `${config.title} From`,
      dataIndex: `${config.key}From`,
      key: `${config.key}From`,
      width: "20%",
      sorter: (a: any, b: any) => a[`${config.key}From`] - b[`${config.key}From`],
    },
    {
      title: `${config.title} To`,
      dataIndex: `${config.key}To`,
      key: `${config.key}To`,
      width: "20%",
      sorter: (a: any, b: any) => a[`${config.key}From`] - b[`${config.key}From`],
    },
    {
      title: "Calculation Percentage",
      dataIndex: "calcPer",
      key: "CalcPer",
      width: "20%",
      sorter: (a, b) => a.calcPer - b.calcPer,
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "Id",
      width: "3%",
      render: (_: any, record: any, index: any) => (
        <Link
          className="edit-btn"
          onClick={() => {
            setDialog({ type: "AddCarAllowance", params: { record: record } });
          }}
        >
          {
            isViewOnly ?
              <EyeFilled />
              :
              <EditTwoTone />
          }
        </Link>
      ),
    },
  ];

  return (
    <>
      <Row
        className="p-3"
        style={{
          backgroundColor: "white",
          paddingTop: 2
        }}
      >      
        <Col span={24}>
          <Row gutter={[8, 8]} className="pb-3"
            align="middle">
            {/* ================= ADD ================= */}
            <Col xs={24} sm={12} md={5} lg={4} xl={3} xxl={2}>
              {
                !isViewOnly ?
                  <Button
                    type="primary"
                    className="add-btn"
                    onClick={() => setDialog({ type: "AddCarAllowance", params: {} })}
                    block
                  >
                    <PlusOutlined />
                    Add Item
                  </Button>
                  : null
              }
            </Col>
            {/* ================= Fuel Type ================= */}
            <Col xs={24} sm={12} md={{ span: 8, offset: 0 }} lg={{ span: 6, offset: 5 }} xl={{ span: 5, offset: 8 }} xxl={{ span: 4, offset: 12 }}>
              <Select
                mode="multiple"
                allowClear
                placeholder="Select Fuel Type"
                maxTagCount="responsive"
                style={{ width: "100%" }}
                onChange={(val) => setPayFrequencyFilter(val)}
                filterOption={(input, option) =>
                  (option?.label?.toString() ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={FuelTypesOptionList}
              />
            </Col>
            {/* ================= Old ================= */}
            <Col xs={24} sm={12} md={4} lg={3} xl={3} xxl={2}>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Old"

                options={[
                  { value: null, label: "All Old" },
                  { value: true, label: "Yes Old" },
                  { value: false, label: "No Old" },
                ]}
                value={isOld}
                onChange={(val) => setIsOld(val)}
              />
            </Col>
            {/* ================= CarAllowanceListType ================= */}
            <Col xs={24} sm={12} md={7} lg={6} xl={5} xxl={4}>
              <Form.Item
                className="custom-form-item"
              // labelAlign={isViewOnly ? "left" : "right"}
              // labelCol={{ span: isViewOnly ? 7 : 12 }}
              // wrapperCol={{ span: 12 }}
              // label="Car Allowance Type"
              >
                <Select
                  className="me-3"
                  style={{
                    height: "22px !important",
                    // minWidth: 235,
                    width: "100%",
                    lineHeight: "22px !important",
                  }}
                  placeholder="Select Car Allowance List Type"
                  value={listParams?.carAllowancesListType}
                  options={CarAllowanceOptionList}
                  onChange={(val: any) => {
                    setListParams({ ...listParams, carAllowancesListType: val });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={24} style={{ height: window.innerHeight - 350, overflowY: "scroll" }}>
          <Table
            dataSource={carAllowancesTypeListData}
            columns={columns}
            size="small"
            className="aoa-custom-table border-top-table"
            loading={{
              spinning: loading,
              indicator: (
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
                />
              ),
            }}
            locale={{
              triggerDesc: "",
              triggerAsc: "",
              cancelSort: "",
            }}
            pagination={{
              defaultPageSize: 15,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              showSizeChanger: true,
              total: carAllowancesTypeListData?.length,
              pageSizeOptions: ["15", "25", "50", "100"],
              onChange: (page, pageSize) =>
                setPagination({ current: page, pageSize }),
            }}            
            scroll={{ x: 700 }}
          />
        </Col>
      </Row>
    </>
  );
};

export default CarAllowances;
